<template>
  <ButtonView v-for="size in [4, 5, 6, 7, 8, 9]" :key="size" type="shaded" color="foreground" size="small" @click="editor.chain().focus().setVideoEmbedSize(Math.pow(size, 2) * 10).run()">
    <i class="fas fa-film" :style="{ 'font-size': 0.5 + size * 0.1 + 'em' }"></i>
  </ButtonView>
  <i class="fa-light fa-pipe mx-2 text-muted"></i>
  <ButtonView v-for="ratio in ratios" :key="ratio.title" type="shaded" color="foreground" size="small" @click="editor.chain().focus().setVideoEmbedAspectRatio(ratio.value).run()">
    {{ ratio.title }}
  </ButtonView>
</template>

<script setup>
import ButtonView from "../../../general/ButtonView.vue";

const props = defineProps({
  editor: Object,
  config: Object
});

const ratios = [
  {
    title: "16:9",
    value: 16 / 9
  },
  {
    title: "4:3",
    value: 4/3
  }
];

</script>